import Home from '../Pages/home/index';
import FoundationIntro from '../Pages/foundation-intro/index';
import Constitution from '../Pages/constitution/index';
import Certificates from '../Pages/certificates/index';
import Honors from '../Pages/honors/index';
import BoardMembers from '../Pages/board-members/index';
import Regulations from '../Pages/regulations/index';
import ProjectDisclosure from '../Pages/project-disclosure/index';
import AuditReports from '../Pages/audit-reports/index';
import AnnualReports from '../Pages/annual-reports/index';
import BoardMaterials from '../Pages/board-materials/index';
import Partners from '../Pages/partners/index';
import Contact from '../Pages/contact/index';
import Article from '../Pages/article/index';

const routerList = [
    {
        path: '',
        breadcrumbName: '首页',
        component: Home
    },
    {
        path: 'foundation-intro',
        breadcrumbName: '基金会简介',
        component: FoundationIntro
    },
    {
        path: 'constitution',
        breadcrumbName: '章程',
        component: Constitution
    },
    {
        path: 'certificates',
        breadcrumbName: '证照',
        component: Certificates
    },
    {
        path: 'honors',
        breadcrumbName: '荣誉认证',
        component: Honors
    },
    {
        path: 'board-members',
        breadcrumbName: '理事会成员',
        component: BoardMembers
    },
    {
        path: 'partners',
        breadcrumbName: '合作伙伴',
        component: Partners
    },
    {
        path: 'regulations',
        breadcrumbName: '规章制度',
        component: Regulations
    },
    {
        path: 'project-disclosure',
        breadcrumbName: '立项报告',
        component: ProjectDisclosure
    },
    {
        path: 'audit-reports',
        breadcrumbName: '审计报告',
        component: AuditReports
    },
    {
        path: 'annual-reports',
        breadcrumbName: '年度报告',
        component: AnnualReports
    },
    {
        path: 'board-materials',
        breadcrumbName: '理事会资料',
        component: BoardMaterials
    },
    {
        path: 'contact',
        breadcrumbName: '联系我们',
        component: Contact
    },
    {
        path: 'article/:dataId/:articleId',
        breadcrumbName: '文章详情',
        component: Article
    }
]

export default routerList;